import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
import { setCachedCompanyTodoCard, toCompanyTodoCard } from "./companyTodoCards";

/**
 * Keeps the overview's card for the selected company current from the dashboard's own To-do summary,
 * which the header reloads on an interval and adjusts as To-dos are handled. Runs on the summary only:
 * a company switch by itself must not write the old summary under the new company.
 */
function useSyncSelectedCompanyTodoCard() {
  const personId = useSelector((store: AppState) => store.auth.loggedInUser.personId);
  const selectedCompany = useSelector((store: AppState) => store.auth.selectedCompany);
  const todoSummary = useSelector((store: AppState) => store.todos.todoSummary);

  React.useEffect(() => {
    if (!todoSummary || !selectedCompany?.id || !personId) return;
    setCachedCompanyTodoCard(personId, toCompanyTodoCard(selectedCompany, "loaded", todoSummary));
  }, [todoSummary]);
}

export default useSyncSelectedCompanyTodoCard;
